import { default as PostCreate } from "./post-create";

export default PostCreate;